// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskPatientLoginLayout.styles';
import {
  KioskWelcomeHeader,
  KioskWelcomeFooter,
  KioskPatientLoginMain,
  KioskIdelScreen
} from '..';

export class KioskPatientLoginLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <KioskWelcomeHeader />
        <KioskPatientLoginMain />
        <KioskWelcomeFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskPatientLoginLayout);
